export const storeFeatureTranslationJP = {
  StoreSettingPage: {
    head_title: '店舗設定一覧',
    search: '絞り込み',
    target_date: '店舗・食材管理システム対象日',
    store_code: '店舗コード',
    store_name: '店舗名',
    sale_type: '販売タイプ',
    consistency_check: '店舗固有設定',
    unspecified: '指定なし',
    only: 'ありのみ',
    none_only: 'なしのみ',
    ng_number_check: '食材管理登録漏れチェック',
    all: '全て',
    ok: 'OK',
    ng: 'NG',
    can_be: 'あり',
    subject: '件',
    unchecked: '未チェック',
    select_all: '全選択',
    unselect_all: '解除',
    individual_setting: '個別設定',
    food_registration_leak_check: '食材管理登録漏れ／<br/>個別設定有無チェック',
    save: '保存',
    register_pattern: 'レジパターン',
    application_pattern: '適用パターン',
    consistency_html: '店舗固有設定<br />有無',
    ingredient_management_registration_omission_check: '食材管理登録漏れ<br />チェック',
    no_data_changed: 'データは変更されていません',
    warn_input_saletype_and_counter_pattern_required: '販売タイプとレジパターンを入力してください',
  },
  StoreSettingDetailPage: {
    head_title: '店舗別設定',
    sale_type: '販売タイプ',
    counter_pattern: 'レジパターン',
    filter_condition: '絞り込み条件',
    time_frame: '起動時間帯',
    eating_way: '食べ方',
    eating_way_setting: 'メニューブック割当',
    assigned_time_frame: '表示時間帯',
    menu_assignment: 'メニュー割当',
    assignment_status_show_all: '全て表示',
    assignment_status_assigned: '割当済みのみ表示',
    assignment_status_unassigned: '未割当のみ表示',
    menu: 'メニュー',
    delete: '削除データ',
    show_all: '削除データ含めて表示',
    show_valid: '削除データ非表示',
    show_deleted: '削除データのみ表示',
    related_pos: '関連するレジ情報',
    deadline: '有効期限',
    valid_date_title: '以下の日付に有効なものを表示',
    search: '絞り込み',
    collapse_all: '全てを閉じる',
    expand_all: '全て開く',
    individual_store_settings_available: '店舗個別設定あり',
    show_changes_only: '変更部分のみ表示',
    unassigned: '未割当',
    menu_book: 'メニューブック',
    course: 'コース',
    genre: 'ジャンル',
    subgenre: 'サブジャンル',
    name: '名称',
    pos_code: 'POSコード',
    mo_display: '表示',
    enable_or_disable: '有効／無効',
    enable: '有効',
    disable: '無効',
    sub_menu_group: 'サブメニューグループ',
    sub_menu_group_cd: '構成グループNo',
    sub_menu: 'サブメニュー',
    not_apply: '該当なし',
    no_option: '選択なし',
    warn_input_saletype_and_counter_pattern_required: '未設定販売タイプや適用パターンしていない店舗',
    warn_filter_time_frame_required: '起動時間帯が必須です。',
    warn_filter_eating_way_required: '食べ方が必須です。',
    warn_filter_assigned_time_frame_required: '表示時間帯が必須です。',
    warn_filter_menu_book_required: 'メニューブックが必須です。',
  },
  MobileOrderDisplayModal: {
    head_title: '店舗個別設定',
    menu_information: '〇メニュー情報',
    store: '店舗',
    save: '保存',
  },
};
